export const todayStr = () => new Date().toISOString().split('T')[0];

export const isValidDateStr = (d) => !!(d && String(d).trim());

export const toGBDate = (value) => {
  if (!value) return '—';
  try {
    const d = new Date(value);
    return isNaN(d.getTime()) ? '—' : d.toLocaleDateString('en-GB');
  } catch {
    return '—';
  }
};

export const toGBDateTime = (value) => {
  if (!value) return '—';
  try {
    const d = new Date(value);
    return isNaN(d.getTime()) ? '—' : d.toLocaleString('en-GB');
  } catch {
    return '—';
  }
};

export const uniq = (arr) => [...new Set(arr.filter(Boolean))];

export const getStatusText = (r) =>
  r.status ?? r.Status ?? r.statusDesc ?? (Number(r.errorCount ?? r.ErrorCount ?? 0) > 0 ? 'Failed' : 'Loaded');

export function transformRow(f) {
  const id = f.ID ?? f.id ?? f.FileIncomingID ?? f.fileIncomingId ?? null;
  const fileName = f.FileName ?? f.fileName ?? '';
  const rawDate = f.dateLoaded ?? f.DateFileLoad ?? null;

  return {
    id,
    fileIncomingId: id,
    fileName,
    unit: f.Unit ?? f.unit ?? '—',
    evn: f.EVN ?? f.evn ?? '—',
    meterID: f.MeterID ?? f.meterID ?? '—',
    status: getStatusText(f),
    errorMessage: f.ErrorMessage ?? f.errorMessage ?? null,
    dataDate: f['Data Date'] ?? f.dataDate ?? f.DataDate ?? null,
    rawDate,
    dateLoaded: toGBDateTime(rawDate),
    dataProvider: f.DataProvider ?? f.dataProvider ?? '—',
  };
}

export function buildOptions(rows) {
  return {
    fileNameOptions:     uniq(rows.map((r) => r.fileName)),
    dataProviderOptions: uniq(rows.map((r) => r.dataProvider).filter((v) => v && v !== '—')),
  };
}

export function filterRows(rows, { filters, searchQuery, statusView, subStatusView = [] }) {
  const q = (searchQuery || '').toLowerCase();
  const activeSubStatuses = subStatusView.filter(Boolean);
  const activeStatuses = Array.isArray(statusView)
    ? statusView.filter((s) => s !== 'All')
    : [];
  const filterByStatus = activeStatuses.length > 0 && !statusView?.includes('All');

  return rows.filter((r) => {
    if (filters.fileName?.length && !filters.fileName.includes(r.fileName)) return false;
    if (filters.dataProvider?.length && !filters.dataProvider.includes(r.dataProvider)) return false;

    if (filterByStatus) {
      const rowStatus = r.status?.toLowerCase() ?? '';
      if (activeSubStatuses.length > 0) {
        // Sub-statuses selected: exact match against those only
        if (!activeSubStatuses.some((s) => rowStatus === s.toLowerCase())) return false;
      } else {
        // No sub-status: match top-level status; 'fail' prefix-matches all Fail - * variants
        if (!activeStatuses.some((s) => {
          const sel = s.toLowerCase();
          if (sel === 'fail') return rowStatus.startsWith('fail');
          return rowStatus === sel;
        })) return false;
      }
    }

    if (q) {
      const hay = `${r.fileName} ${r.status} ${r.dataProvider} ${r.unit} ${r.evn}`.toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });
}
